/* eslint-disable no-console */

import { register } from 'register-service-worker'
import Vue from 'vue'
import { checkRole } from './utils/authUtils'
import { DRIVER_ROLES } from './constants/userRoles'

if (
  process.env.NODE_ENV === 'production' ||
  process.env.NODE_ENV === 'development'
) {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        'App is being served from cache by a service worker.'
      )
    },

    registered() {
      console.log('Service worker has been registered.')
    },

    cached() {
      console.log('Content has been cached for offline use.')
    },

    updatefound() {
      console.log('New content is downloading.')
    },

    updated(registration) {
      console.log('New content is available; please refresh.')
      notifyNewVersionAvailable(registration)
    },

    offline() {
      console.log(
        'No internet connection found. App is running in offline mode.'
      )
    },

    error(error) {
      console.error(
        'Error during service worker registration:',
        error
      )
    }
  })
}

function notifyNewVersionAvailable(registration) {
  if (!checkRole('admin') && !DRIVER_ROLES.some(checkRole)) {
    return
  }

  const message =
    'Hay una nueva versión disponible de la aplicación. Recarga la página para ver los últimos cambios.'

  const params = {
    title: 'Nueva versión disponible',
    message,

    confirmButton: {
      text: 'Recargar ahora',
      variant: 'primary',
      outline: false
    },

    cancelButton: {
      text: 'Más tarde',
      variant: 'secondary',
      outline: true
    }
  }

  Vue.prototype.$confirmModal
    .confirm(message, params)
    .then(confirmed => {
      if (!confirmed) {
        return
      }

      if (!registration || !registration.waiting) {
        window.location.reload()
        return
      }

      const waitingWorker = registration.waiting

      // Esperamos a que el nuevo Service Worker tome el control
      // antes de recargar la página.
      navigator.serviceWorker.addEventListener(
        'controllerchange',
        () => {
          window.location.reload()
        },
        { once: true }
      )

      // Le indicamos al nuevo Service Worker que se active
      // inmediatamente.
      waitingWorker.postMessage({
        type: 'SKIP_WAITING'
      })
    })
}